import React, { useState } from 'react';

import './admin.css'
import Swal from 'sweetalert2';

import key from './key.png'
import axios from 'axios';
import link from '../../backendlink';
import MainAdmin from './Mainadmin';
import AdminDash from './AdminDash';
function Admin() {

    

    const [val, setVal] = useState('');
    const [flag, setFlag] = useState(false);
    const handleChange = (event) => {
        setVal(event.target.value);
    };


    const btnClicked = () => {
        if (val === 'krushna') {
            setFlag(true);
        }
        else {
            Swal.fire({
                title: "Wrong Key !!",
                text: "Please try again !",
                icon: "error"
            });
            setVal('');
        }
    }

    return (

        <div className='admin'>
            
            {flag ? (
                <AdminDash />
            ) : (
                <div>

                    <div className="admin-sec">

                        <h2>ADMIN ACCESS</h2>
                        <img src={key} alt="" className='adminkey' />
                        <input type="password" placeholder='ENTER A SECURITY KEY T0 ACCESS ADMIN' value={val} onChange={handleChange} />
                        <button onClick={btnClicked}>GET ACCESS</button>

                    </div>
                </div>
            )}


        </div>
    );
}
export default Admin;


